// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeUploadGetStatusBody = {
  mediaId: string;
};

export type typeUploadGetStatusOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    mediaId: string;
    purpose: "avatar" | "poolBanner" | "chatPhoto" | "chatPdf";
    status:
      | "pendingUpload"
      | "processing"
      | "published"
      | "pendingReview"
      | "heldOnBudget"
      | "failed";
    variants?: {
      original: { url: string };
      large: { url: string };
      thumbnail: { url: string };
    } | null;
  };
};

export type typeUploadGetStatusOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUploadGetStatusOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUploadGetStatusOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaUploadGetStatusBody = {
  type: "object",
  properties: { mediaId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["mediaId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createUploadGetStatus(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaUploadGetStatusBody);
  }

  return async function postUploadGetStatus(
    payload: typeUploadGetStatusBody,
  ): Promise<typeUploadGetStatusOutput200 | typeUploadGetStatusOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postUploadGetStatus" failed before calling the network. #3fd152b4ebfd`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#3fd152b4ebfd" },
        },
        data: null,
      } as typeUploadGetStatusOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/upload/get-status`,
      httpMethod: "POST",
      options,
    })) as typeUploadGetStatusOutput200 | typeUploadGetStatusOutput400;
  };
}
